import { apolloProvider } from '@/modules/GraphQL';
import { apolloProvider as myStageApolloProvider } from '@/modules/myStageGraphQL';
import { STUDENT_OTHER_SETTING } from '@/graphql/student';
import { USER_OTHER_SETTING_MSB } from '@/graphql/userSetting';
import logger from '@/modules/Logger';

export const GetUserOtherSettingService = {
  msb: async () => {
    logger.debug(`[UserOtherSetting] Fetching from MSB GraphQL endpoint`, {
      operation: 'user:getUserOtherSetting'
    });

    const client = myStageApolloProvider.defaultClient;

    try {
      const { data } = await client.query({
        query: USER_OTHER_SETTING_MSB,
        fetchPolicy: 'no-cache'
      });

      return data.getUserOtherSetting || {};
    } catch (error) {
      logger.error('Failed to get user other setting', {
        operation: 'user:getUserOtherSetting',
        error: error.message
      });
      return {};
    }
  },

  mbti: async () => {
    logger.debug(`[Student][OtherSetting] Fetching from MBTI GraphQL endpoint`, {
      operation: 'student:getUserOtherSetting'
    });

    const client = apolloProvider.defaultClient;
    const logPrefix = '[MTZ Release] ';

    try {
      const { data } = await client.query({
        query: STUDENT_OTHER_SETTING,
        fetchPolicy: 'no-cache'
      });

      return data.student_other_setting || {};
    } catch (error) {
      logger.error(logPrefix + 'Failed student other setting request', {
        operation: 'lesson:detect-user-timezone',
        error: error.message
      });
      return {};
    }
  }
};
